import { Controller } from "@hotwired/stimulus"
import { Litepicker } from "litepicker"

export default class extends Controller {
  static targets = ["hidden", "displayed"]
  static values = { min: String, max: String, lang: String }

  initialize() {
    this.litepicker = this.createLitepicker()
  }

  createLitepicker() {
    return new Litepicker({
      element: this.displayedTarget,
      minDate: this.minValue,
      maxDate: this.maxValue,
      format: "DD/MM/YYYY",
      lang: this.langValue,
      DayOfWeekStart: 1,
      setup: (picker) => {
        picker.on("selected", (date) => {
          this.hiddenTarget.value = date.format("YYYY-MM-DD")
        })
      },
    })
  }

  disconnect() {
    if (this.litepicker) {
      this.litepicker.destroy()
    }
  }
}
